import { defineMessages } from "react-intl";

export const messages = defineMessages({
  empty: {
    id: "FpIcp9",
    defaultMessage: "No customers found",
  },
});

export const columnsMessages = defineMessages({
  name: {
    id: "nZDQbr",
    defaultMessage: "Customer name",
    description: "column header",
  },
  email: {
    id: "945a4a",
    defaultMessage: "Customer e-mail",
    description: "column header",
  },
  orders: {
    id: "MTGT8E",
    defaultMessage: "No. of orders",
    description: "column header",
  },
});
